module.exports = __webpack_public_path__ + "static/assets/f3d2cc01ffb4aaea4b4e3b50e35fdf73.png";